<button
  pButton
  pRipple
  type="button"
  pTooltip="{{ languageKey.DELETE | translateKey }}"
  tooltipPosition="left"
  icon="pi pi-trash"
  class="p-button-rounded p-button-raised p-button-secondary mr-2"
></button>
